import React, { FC } from 'react';
import Create from 'components/document-templates/components/Create';

const Screen: FC = () => (
  <Create
    templatesEntityName="client-templates"
    templatesDropdownsEntityName="client-template-dropdowns"
    templatesDropdownsEntityEndpoint="client-templates/dropdown-options"
  />
);

export default Screen;
